<ng-container *ngIf="industries.length">
  <div class="ds-grid">
    <div class="row mt-7">
      <div class="col">
        <h2 class="ds-heading--l text-center mb-4 mb-sm-0">{{componentTexts?.headline}}</h2>
      </div>
    </div>
    <div class="row mx-auto justify-content-center">
      <div class="col-12 col-md-10 col-lg-9 col-xl-12 px-0">
        <div class="row px-0 justify-content-center">
          <ng-container *ngFor="let industry of industries; let last = last; let index = index;">
            <div [ngClass]="{'d-none d-lg-block': index===5}"
                 class="col-6 col-sm-4 col-lg-3 industry-container mt-6 px-0">
              <div
                (click)="openSearchResult(industry)"
                (keydown.enter)="openSearchResult(industry)"
                [tabindex]="0"
                class="me-5 focusable focusable__element industry-cell ds-cursor--pointer text-center"
                [class.me-sm-0]="index === 2 || last"
                [class.me-sm-4]="index !== 2 && !last"
                [class.me-md-5]="index !== 2 && !last"
                [class.me-lg-0]="index === 3"
                [class.me-lg-5]="index === 2"
                [class.me-xl-5]="!last"
              >
                <div class="image-container mb-3 mx-auto">
                  <img alt="{{industry.name}} image"
                       src="assets/images/homepage/browse-industries/{{industry.name}}.svg">
                </div>
                <p class="d-none d-sm-block ds-heading--xs ds-color--grey-1 flex-grow-1 mb-0">{{industry.name}}</p>
                <p class="d-sm-none ds-heading--xxs ds-font--medium flex-grow-1 mb-0">{{industry.name}}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="separator w-100 mt-6 mt-sm-7"></div>
  </div>
</ng-container>
